export class FardeUpdate {
  serviceIds: number[];
  includeServicesInChemises: boolean;
  keepExistingChemisesService: boolean;
  classementId: number;
  serviceId: number;
  description: string;
  localisation: string;
  remarques: string;
  classementAffine: string;
  accesRestreint: boolean;
  archive: boolean;
}
